import React from 'react';
import { Link } from 'react-router-dom';
import './StaffInfo.css';

function StaffInfo({ staffData, rsvpData }) {
  if (!staffData) {
    return (
      <div className="staff-info-container">
        <div className="no-data-message">
          <h2>No staff information available</h2>
          <Link to="/" className="back-button">Return to RSVP</Link>
        </div>
      </div>
    );
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    return timestamp.toDate ? timestamp.toDate().toLocaleString() : new Date(timestamp).toLocaleString();
  };

  return (
    <div className="staff-info-container">
      <div className="staff-info-card">
        <h2>Staff Information</h2>
        <div className="info-section">
          <div className="info-row">
            <span className="info-label">Name:</span>
            <span className="info-value">{staffData.name}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Title:</span>
            <span className="info-value">{staffData.title || 'Staff'}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Email:</span>
            <span className="info-value">{staffData.email}</span>
          </div>
        </div>
      </div>

      {rsvpData ? (
        <div className="rsvp-info-card">
          <h2>RSVP Information</h2>
          <div className="info-section">
            <div className="info-row">
              <span className="info-label">Status:</span>
              <span className="info-value status">{rsvpData.attending ? 'Attending' : 'Not Attending'}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Guest Count:</span>
              <span className="info-value">{rsvpData.guestCount}</span>
            </div>

            {rsvpData.guests && rsvpData.guests.length > 0 && (
              <div className="guests-section">
                <h3>Guests</h3>
                {rsvpData.guests.map((guest, index) => (
                  <div key={index} className="guest-card">
                    <div className="info-row">
                      <span className="info-label">Name:</span>
                      <span className="info-value">{guest.name}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Relationship:</span>
                      <span className="info-value">{guest.relationship}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="info-row timestamps">
              <span className="info-label">RSVP Created:</span>
              <span className="info-value small">{formatDate(rsvpData.createdAt)}</span>
            </div>
            <div className="info-row timestamps">
              <span className="info-label">Last Updated:</span>
              <span className="info-value small">{formatDate(rsvpData.updatedAt)}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="no-rsvp-message">
          <h3>No RSVP Information</h3>
          <p>You have not yet RSVP'd to the ceremony.</p>
        </div>
      )}

      <div className="ceremony-info-card">
        <h2>Ceremony Information</h2>
        <div className="info-section">
          <div className="info-row">
            <span className="info-label">Date:</span>
            <span className="info-value">Monday, May 4, 2026</span>
          </div>
          <div className="info-row">
            <span className="info-label">Time:</span>
            <span className="info-value">6:00 PM to 8:00 PM</span>
          </div>
          <div className="info-row">
            <span className="info-label">Location:</span>
            <span className="info-value">Veterans Memorial High School Auditorium</span>
          </div>
          <div className="info-row">
            <span className="info-label">Reception:</span>
            <span className="info-value">Following the ceremony, in the cafeteria</span>
          </div>
          <div className="info-row">
            <span className="info-label">Dress Code:</span>
            <span className="info-value">Semi-formal</span>
          </div>
        </div>
      </div>

      <div className="action-buttons">
        <Link to="/" className="back-button">Return to RSVP</Link>
        <a href="https://cte-rsvp.joshuabailey.us/upload" target="_blank" rel="noopener noreferrer" className="media-button">Upload your memories &rarr;</a>
      </div>
    </div>
  );
}

export default StaffInfo;
